<template lang="pug">
  ValidationObserver(v-slot="{ invalid, handleSubmit }" ref="validator")
    v-form.px-sm-0.px-md-10.pb-0.pb-sm-2.pb-md-4(@submit.prevent="handleSubmit(submitDataForm)")
      v-container(fluid)
        v-row
          v-col(cols="12" sm="6" md="4" lg="4")
            BaseTextField(rules="required" v-model="form.name", :label="translations.label.name")
          v-col(cols="12" sm="6" md="4" lg="4")
            BaseTextField(rules="required" v-model="form.country", :label="translations.label.country")
          v-col(cols="12" sm="6" md="4" lg="4")
            BaseTextField(rules="required" v-model="form.countryCode", :label="translations.label.countryCode")
          v-col(cols="12" sm="6" md="4" lg="4")
            BaseSelectField(rules="required", :items="providers" v-model="form.provider", :label="translations.label.provider")
          v-col(cols="12" sm="6" md="4" lg="4")
            BaseTextField(rules="required" v-model="form.providerId", :label="translations.label.providerId")
          v-col(cols="12" sm="6" md="4" lg="4")
            ValidationProvider(rules="required" v-slot="{ errors }")
              v-select(v-model="selectSport", :items="sports" item-text="text" item-value="value" return-object :error="errors.length > 0")
                template(v-slot:label)
                  v-icon.pr-1(color="red accent-2" size="12") mdi-asterisk
                  | {{ translations.label.sport }}
              span.red--text.text--accent-2(v-if="errors.length > 0")
                v-icon(color="red accent-2") mdi-alert
                |  {{ errors[0] }}
          v-col(cols="12" sm="6" md="4" lg="4")
            BaseTextField(rules="required" v-model="form.providerSeason", :label="translations.label.providerSeason")
          v-col.pa-2.pa-md-6(cols="12")
            v-btn.float-right.big(:disabled="invalid"
                color="primary"
                type="submit"
                :loading="loadingCreate") {{ translations.buttons.create }}

</template>

<script>

  export default {
    name: "CompetitionCreate",
    props: {
      clearForm: {
        type: Boolean,
        default: false
      },
      translations: {
        type: Object,
        default: function(){
          return {}
        }
      },
      providers:{
        type: Array,
        default: function(){
          return []
        }
      },
      sports:{
        type: Array,
        default: function(){
          return []
        }
      },
    },
    data:() => ({
      form:{
        name: '',
        country: '',
        countryCode: '',
        provider: '',
        providerId: '',
        sport: '',
        providerSeason: '',
      },
      selectSport: {
        text: '',
        value: ''
      },
    }),
    computed: {
      loadingCreate() {
        return this.$store.state.statusCode.createCompetition.loading;
      },
      stateCreate() {
        return this.$store.state.statusCode.createCompetition.state;
      },
    },
    watch: {
      clearForm: function(val){
        if (val){
          this.clearFields();
          this.$refs.validator.reset();
        }
      },
      stateCreate: function(val){
        if (val == 200) {
          this.$emit('successCreate');
        }
      },
    },
    created(){
      this.clearFields();
    },
    methods:{
      submitDataForm(){
        const formSend = {
          data: {
            name: this.form.name,
            country: this.form.country,
            countryCode: this.form.countryCode,
            provider: this.form.provider,
            providerId: this.form.providerId,
            sport: this.selectSport.value,
            providerSeason: this.form.providerSeason,
          }
        };
        this.$store.dispatch('createCompetition', formSend);
      },
      clearFields(){
        this.form.name = '';
        this.form.country = '';
        this.form.countryCode = '';
        this.form.provider = '';
        this.form.providerId = '';
        this.form.sport = '';
        this.form.providerSeason = '';
        this.selectSport.text = '';
        this.selectSport.value = '';
      },
    }
  }
</script>

<style lang="sass">
</style>